import React from 'react';
import './style.scss';
import temp from '../../../temp/config';
import FullModal from './FullModal';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isMobileFun, createFilePath } from '../../../utils/obj-utils';
export default function index(props) {
  const isMobile = isMobileFun();
  const { setFlag, videoSrc, dmpUrl } = props;
  return (
    <FullModal>
      <div className="detailsVideo">
        <div>
          <img
            alt="广汽本田"
            src={createFilePath('/breeze-guide/common/play_close.png')}
            onClick={() => {
              setFlag(false);
              window.Dmp.clickAction('manual-2-btn0', '', '');
            }}
          />
        </div>
        <video src={`${createFilePath(videoSrc.value)}`} controls preload="auto" height="100%" width="100%" autoPlay="autoPlay"></video>
      </div>
    </FullModal>
  );
}
